import { JSXElementConstructor } from 'react';

import {
  CapabilityApplications,
  CapabilityApplicationType,
} from '../account-api';
import { IconProps } from '../design-system';

export enum AppSlugs {
  BulkHpi = 'bulk-hpi',
  BulkPropertyData = 'bulk-data',
  BulkRpi = 'bulk-rpi',
  DeveloperCenter = 'developer-center',
  MarketPulse = 'market-pulse',
  // These were created prior to the capability system and continue to use legacy app slugs
  // for engagement tracking purposes. New applications should use the capability application key
  // reference the CapabilityApplications type definition for a list of available application keys.
  // Customer-Facing Frontend Apps Only, No ties to ehrm or billing
  Platform = 'Platform',
  OrgAdmin = 'Org Admin',
  UserAdmin = 'User Admin',
  // Internal Frontend Apps Only, Not created in ehrm
  AccessSolutionsPlatform = 'Access Solutions Platform',
  AccessCanaryCommand = 'Access Canary Command',
  AccessPartnerTools = 'Access Partner Tools',
  AgileOpsCommandCenter = 'AgileOps Command Center',
  CerberusExplorer = 'Cerberus Explorer',
  BulkData = 'Bulk Data',
  EngTools = 'Engineering Tools',
  ReportRepair = 'Report Repair',
  ReportBuilder = 'Report Builder',
  CanaryAdmin = 'Canary Admin',
  ClientAdmin = 'Client Admin',
  PlatformAdmin = 'Platform Admin',
  // HCS Products, Permissions linked to subscriptions
  PropertyExplorer = 'Value Report',
  DataExplorer = 'Analytics API',
  CanaryAI = 'CanaryAI',
  PortfolioMonitor = 'Portfolio Monitor',
  AcquisitionExplorer = 'Lead Feed',
  MarketInsights = 'Market Insights',

  SavedLists = 'Saved Lists',
  AgileSuite = 'Order Manager',
  ListingsManager = 'agent-listings',
  GoogleLsaManager = 'ads-manager',
}

export interface AppConfig {
  appSlugForEngagement: AppSlugs;
  type: CapabilityApplicationType;
  applicationKey: CapabilityApplications;
  rootPath: `/${string}`;
  name: string;
  globalHeaderTitle?: string;
  Icon: JSXElementConstructor<IconProps>;
  descriptionLong: string | string[];
  descriptionShort: string;
  marketingUrl?: string;
  marketingImage?: string;
  /** When true the card is displayed in a greyed-out, non-interactive "coming soon" state. */
  comingSoon?: boolean;
  /** When true, hide the app tile/entry for users who do not have access. */
  hideIfNoAccess?: boolean;
  hideIfNoAccessForAgentPlans?: boolean;
}

export enum AgileProductGroupings {
  AgileInsights = 'Agile Insights',
  AgileEvaluation = 'Agile Evaluation',
  AgileInspection = 'Agile Inspection',
}

export interface AgileSuiteProductConfig
  extends Omit<
    AppConfig,
    'rootPath' | 'appSlugForEngagement' | 'applicationKey' | 'type'
  > {
  // Keep consistent contract the AppConfig to reuse components more easily
  appSlugForEngagement: AgileProductGroupings;
}
export interface AgileSuiteProductConfigExtended {
  hasAccess?: boolean;
  // Keep consistent contract the AppConfigExtended to reuse components more easily
  appConfig: AgileSuiteProductConfig;
}

export interface AppConfigExtended {
  hasAccess?: boolean;
  appConfig: AppConfig;
}
